<template>
  <v-container>
    <v-row id="profile-layout" class="strategio-titles-windows" style="padding-bottom: 0px; padding-top: 30px;">
      <v-col cols="5" align-self="center">
        <v-icon  :color="'black'"  style="font-size:52px;padding-bottom: 30px; padding-right: 10px;">ico-icon-user</v-icon>
        <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
          Mi Perfil
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-card elevation="0" class="pa-5" style="border-radius: 10px !important;">
          <v-card-text class="pl-12 pt-5">
            <span style="color:#25235F;font-size:25px">Datos del Usuario</span>
          </v-card-text>

          <v-card-text>
            <v-container>
                <v-col class="px-4 ma-3" align-self="center">
                  <v-card-text class="pl-0" style="padding-bottom:22px">
                    <v-icon color="'black'" style="padding-right:12px;">ico-icon-mail</v-icon>
                    <span style="font-family:'Open Sans';color:black;font-size:15px;font-weight:bold">Correo o código de usuario</span>
                  </v-card-text>
                  
                  <v-text-field
                    solo
                    id="txtMail"
                    name="txtMail"
                    label="Correo o código de usuario"
                    v-model="userData.mail"
                    background-color="#E0DCDC"
                    style="width:350px"
                  ></v-text-field>

                  <v-card-text class="pl-0 pt-2" style="padding-bottom:22px">
                    <v-icon color="black" style="padding-right:12px;">ico-icon-user</v-icon>
                    <span style="font-family:'Open Sans';color:black;font-size:18px;font-weight:bold">Nombres y Apellidos</span>
                  </v-card-text>                  
                  
                  <v-text-field
                    single-line
                    id="txtUserName"
                    name="txtUserName"
                    label="Nombre"
                    v-model="userData.name"
                    append-icon="ico-icon-edit"
                    class="pt-0"
                    style="width:350px"
                  ></v-text-field>

                  <!-- <v-card-text class="pl-0" style="padding-bottom:22px">
                    <v-icon color="'black'" style="padding-right:12px;"
                    >ico-icon-company</v-icon>
                    <span style="font-family:'Open Sans';color:black;font-size:15px;font-weight:bold">
                      Compañía</span>
                  </v-card-text>
                  
                  <v-text-field
                    solo
                    id="txtDescription"
                    name="txtDescription"
                    label="Compañía"
                    v-model="userData.company"
                    hide-details="True"
                    background-color="#E0DCDC"
                    style="width:350px"
                  ></v-text-field> -->

                  <v-card-text class="pl-0 pt-4" style="padding-bottom:22px">
                    <v-icon color="'black'" style="padding-right:12px;"
                    >ico-icon-briefcase</v-icon>
                    <span style="font-family:'Open Sans';color:black;font-size:18px;font-weight:bold">Cargo o descripción</span>
                  </v-card-text>
                  
                  <v-text-field
                    single-line
                    id="txtDescription"
                    name="txtDescription"
                    label="Cargo o descripción"
                    v-model="userData.description"
                    append-icon="ico-icon-edit"
                    style="width:350px"
                  ></v-text-field>

                  <v-card-text class="pl-0 pt-4" style="padding-bottom:22px">
                    <v-icon color="'black'" style="padding-right:12px;">ico-icon-mobile</v-icon>
                    <span style="font-family:'Open Sans';color:black;font-size:18px;font-weight:bold">Teléfono</span>
                  </v-card-text>
                
                  <v-text-field
                    single-line
                    id="txtPhone"
                    name="txtPhone"
                    label="Teléfono"
                    v-model="userData.phone"
                    append-icon="ico-icon-edit"
                    style="width:350px"
                  ></v-text-field>

                  <v-card-actions v-show="!this.isNewUser" class="white" align="center" style="width: 50%;">
                    <v-btn elevation="0" class="strategio-user-buttons" @click="updateUserProfile()">
                      <span style="color:white;font-weight:700;font-family:'Open Sans';">Actualizar Datos</span>
                      <v-icon color="white">mdi-refresh</v-icon>
                    </v-btn>
                  </v-card-actions>


                </v-col>
                <!-- <v-col cols="12" md="6" class="px-4 ma-3" align-self="center">
                    <v-col v-show="!this.isNewUser" cols="12" md="4" class="px-4" align-self="center"> </v-col>
                </v-col> -->
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card elevation="0" class="pa-5" style="border-radius: 10px !important; height: 100%;">
          <v-card-text class="pl-12 pt-5">
            <span style="color:#25235F;font-size:25px">Seguridad</span>
          </v-card-text>

          <v-card-text>
            <v-container>
              <v-row>
                  <v-col cols="12" md="4" >
                    <v-checkbox color="#23A2D9"
                      style="color:#23A2D9 !important;"
                      label="Está habilitado para visualizar reportes"
                      v-model="userData.isEnabled"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4" class="px-4">
                    <v-select
                          bottom
                          item-text="name"
                          item-value="type"
                          :items="items"
                          :hint="hintMessage"
                          persistent-hint
                          label="Tipo de usuario"
                          v-model="userData.userType"
                    >
                      <v-tooltip class="layout column" top slot="item" slot-scope="data">
                        <v-col slot="activator">
                          {{ data.item.name }}
                        </v-col>
                        <v-col>{{ data.item.description }}</v-col>
                      </v-tooltip>
                    </v-select>
                  </v-col>

                  <v-checkbox
                    v-if="this.userData.userType === 'ADMIN' || this.userData.manageUserAccess == 1"
                    class="pl-3"
                    color="#23A2D9" 
                    style="color:#23A2D9 !important;"
                    label="Permiso para modificacion y/o actualizacion de usuarios"
                    v-model="userData.isEnabled">
                  </v-checkbox>

                  <v-col v-show="!this.isNewUser" cols="12" md="6">
                    <v-card-actions class="white">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="strategio-user-buttons"
                        @click="updateUserAccessLevel()"
                      >
                        <span style="color:white;font-size:17px;font-weight:700;font-family:'Open Sans';">Actualizar Acceso</span>
                      </v-btn>
                    </v-card-actions>
                  </v-col>

                  <v-col v-if="!isMyAccount" cols="12">
                    <v-col v-if="userData.userType === 'NORMAL'" class="strategio-my-account-sub-division" cols="12">
                      Permisos <br v-show="loadedAssignedReports" />
                      <v-subheader v-show="loadedAssignedReports">Se han asignado &nbsp; <b>{{assignedReports.length}}</b>&nbsp; items a este usuario </v-subheader>
                    </v-col>
                    <v-col v-if="userData.userType === 'NORMAL'" cols="12">
                      <show-reports-permisions-dialog 
                        :user-id="userData.userID" 
                        :items-data="itemsTree"
                        :is-new-user="this.isNewUser"
                      ></show-reports-permisions-dialog>
                    </v-col>
                  </v-col>

                  <v-col v-show="this.isNewUser" cols="12">
                    <v-card-actions class="white layout justify-center">
                      <v-btn
                        depressed
                        class="strategio-card-buttons"
                        color="success"
                        :disabled="confirmPassword === '' || confirmPassword !== password"
                        @click="createUser()"
                      >
                        Crear usuario
                      </v-btn>
                    </v-card-actions>
                  </v-col>

              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--
    <v-row id="security-layout">
      <v-col cols="12">
        <v-card elevation="0" class="pa-5" style="border-radius: 10px !important;" >
            
        </v-card>
      </v-col>

    </v-row>

    <v-row id="security-layout" v-if="!isMyAccount || isNewUser" style="margin-bottom: 5%;">
      <v-col cols="12">
        <v-card
          elevation="0"
          class="pa-5"
          style="border-radius: 10px !important;"
        >
          <span style="color:#25235F;font-size:35px;-webkit-text-stroke: 0.8px #25235F;">
              Acceso
          </span>
          <v-card-text style="padding-left:32px !important;padding-right:32px !important;">
            <v-row>
              <v-col cols="12" md="4" >
                <v-checkbox color="#23A2D9"
                  style="color:#23A2D9 !important;"
                  label="Está habilitado para visualizar reportes"
                  v-model="userData.isEnabled"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4" class="px-4">
                <v-select
                      bottom
                      item-text="name"
                      item-value="type"
                      :items="items"
                      :hint="hintMessage"
                      persistent-hint
                      label="Tipo de usuario"
                      v-model="userData.userType"
                >
                  <v-tooltip class="layout column" top slot="item" slot-scope="data">
                    <v-col slot="activator">
                      {{ data.item.name }}
                    </v-col>
                    <v-col>{{ data.item.description }}</v-col>
                  </v-tooltip>
                </v-select>
              </v-col>
              
              <v-spacer></v-spacer>

              <v-col v-show="!this.isNewUser" cols="12" md="4">
                <v-card-actions class="white">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="strategio-user-buttons"
             
                    @click="updateUserAccessLevel()"
                  >
                    <span style="color:white;font-size:17px;font-weight:700;font-family:'Open Sans';">Actualizar Acceso</span>
                  </v-btn>
                </v-card-actions>
              </v-col>
              
            </v-row>
             <v-row>
              <v-col v-if="!isMyAccount" cols="12">
                <v-col v-if="userData.userType === 'NORMAL'" class="strategio-my-account-sub-division" cols="12">
                  Permisos <br v-show="loadedAssignedReports" />
                  <v-subheader v-show="loadedAssignedReports">Se han asignado &nbsp; <b>{{assignedReports.length}}</b>&nbsp; items a este usuario </v-subheader>
                </v-col>
                <v-col v-if="userData.userType === 'NORMAL'" cols="12">
                  <show-reports-permisions-dialog 
                    :user-id="userData.userID" 
                    :items-data="itemsTree"
                    :is-new-user="this.isNewUser"
                  ></show-reports-permisions-dialog>
                </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-show="this.isNewUser" cols="12">
                <v-card-actions class="white layout justify-center">
                  <v-btn
                    depressed
                    class="strategio-card-buttons"
                    color="success"
                    :disabled="confirmPassword === '' || confirmPassword !== password"
                    @click="createUser()"
                  >
                    Crear usuario
                  </v-btn>
                </v-card-actions>
              </v-col>

            </v-row>



          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    -->

    
    <custom-snack-bar></custom-snack-bar>
    <are-you-sure-dialog></are-you-sure-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import {find} from 'lodash'

import eventBus from '../../utils/eventBus'
import introBus from '../../utils/introBus'

import userStorage from '../../storage/userStorage'
import adminStorage from '../../storage/adminStorage'
import ShowReportsPermisionsDialog from '../dialogs/show-reports-permisions-dialog.vue'
import AreYouSureDialog from '../dialogs/are-you-sure-dialog.vue'

import CustomSnackBar from '../snackbars/custom-snack-bar.vue'

export default {
  name: 'user-form',
  created () {
    eventBus.$off('show-updated-Reports')
    eventBus.$on('show-updated-Reports', (data) => {
      this.loadedAssignedReports = true
      this.assignedReports = data
    })
  },
  mounted () {
    // emits to: /components/header-bar/strategio-app-bar.vue
    eventBus.$emit('enable-tutorial-button')

    eventBus.$off('start-user-form-tutorial')
    eventBus.$on('start-user-form-tutorial', () => {
      // Existen varias versiones del formulario
      // Preguntar en que ruta nos encontramos
      let intro = introBus.getIntroBus()
      intro.addSteps([
        {
          element: '#profile-layout',
          intro: 'En esta sección uno podrá alterar el perfil del usuario.'
        },
        {
          element: '#security-layout',
          intro: 'Aquí se podrá crear o modificar la contraseña.'
        },
        {
          element: '#access-layout',
          intro: 'Finalmente, en esta sección se puede manipular el nivel de permisos con el que el usuario contará'
        }
      ].filter((obj) => {
        return document.getElementById(obj.element.split('#')[1])
      }))
      intro.start()
    })
  },
  data () {
    const userInfo = userStorage.getUserInfo()
    var itemList = [
      {
        type: 'NORMAL',
        name: 'Normal',
        description: 'Acceso a perfil, visualizador, favoritos y tutorial'
      },
      {
        type: 'GLOBAL',
        name: 'Global',
        description: 'Acceso NORMAL, más acceso a todos los reportes'
      }
    ]
    if (userInfo.userType === 'ADMIN') {
      itemList.push(
        {
          type: 'SUPERVISOR',
          name: 'Supervisor',
          description: 'Acceso GLOBAL, más herramientas administrativas'
        }
      )
    }
    return {
      password: '',
      confirmPassword: '',
      hidePassword: true,
      canChangePassword: false,
      showReportsDialog: false,
      items: itemList,
      assignedReports: [],
      loadedAssignedReports: false,
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage: 'Cerrar',
      snackActionFunction: () => { this.snackbar = false }
    }
  },
  computed: {
    hintMessage () {
      // return find(this.items, (item) => item.type === this.userData.userType).description
      return find(this.items, (item) => item.type === this.userData.userType) ? find(this.items, (item) => item.type === this.userData.userType).description : ''
    }
  },
  methods: {
    openSnackBar (message, itsOk, snackAction) {
      eventBus.$emit('open-custom-snack-bar', {message, itsOk, snackAction})
    },
    validatePassword () {
      if ( this.password !== this.confirmPassword) { return 'Los contraseñas deben ser iguales' }
      else return ( this.password.length >= 10 && /^(?=.*[A-Z])(?=.*\d)(?=.*[!?\@$])[A-Za-z\d!?\@$]{10,}$/g.test(this.password) ) || 'La contraseña debe tener al menos 10 caracteres alfanuméricos e incluir al menos uno de los siguientes símbolos especiales: !, ?, @, $.' 
    },
    updateUserProfile () {
      if (this.isMyAccount) {
        userStorage.updateUserInfo({
          data: this.userData,
          onSuccess: () => this.openSnackBar('Perfil actualizado', true),
          onError: () => this.openSnackBar('Error al actualizar perfil', false)
        })
      } else {
        adminStorage.updateUserInfo({
          data: this.userData,
          onSuccess: () => this.openSnackBar('Perfil actualizado', true),
          onError: () => this.openSnackBar('Error al actualizar perfil', false)
        })
      }
    },
    updateUserPassword () {
      if (this.isMyAccount) {
        userStorage.updatePassword({
          newPassword: this.password,
          onSuccess: () => {
            this.openSnackBar('Password cambiado', true)
            // console.log(this.showStrategioAppBar)
            if (!this.showStrategioAppBar) {
              this.$router.push('/0')
            }
          },
          onError: () => this.openSnackBar('Error al cambiar de password', false)
        })
      } else {
        adminStorage.updatePassword({
          userID: this.userData.userID,
          newPassword: this.password,
          onSuccess: () => {
            this.openSnackBar('Password cambiado', true)
            if (!this.showStrategioAppBar) {
              this.$router.push('/0')
            }
          },
          onError: () => this.openSnackBar('Error al cambiar de password', false)
        })
      }
    },
    updateUserAccessLevel () {
      adminStorage.updateAccessLevel({
        userID: this.userData.userID,
        newUserType: this.userData.userType,
        isEnabled: this.userData.isEnabled,
        onSuccess: () => this.openSnackBar('Nivel de acceso actualizado', true),
        onError: () => this.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false)
      })
    },
    createUser () {
      adminStorage.createUser({
        userData: {...this.userData, password: this.password, permissions: this.assignedReports},
        onSuccess: (response) => {
          this.password = ''
          this.confirmPassword = ''
          this.canChangePassword = false
          // eslint-disable-next-line
          if (response.data.status == 1 && !['SUPERVISOR', 'GLOBAL'].includes(this.userData.userType)) {
            this.openSnackBar('El usuario ha sido creado pero no puede ver reportes', 'warning', {
              title: 'Ver usuario',
              action: () => {
                this.$router.push(`/user/admin/${response.data.userID}`)
              }
            })
          } else {
            this.openSnackBar('El usuario ha sido creado', true, {
              title: 'Ver usuario',
              action: () => {
                this.$router.push(`/user/admin/${response.data.userID}`)
              }
            })
          }
        },
        onError: (error) => {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            this.password = ''
            this.confirmPassword = ''
            this.canChangePassword = false
            this.openSnackBar('El codigo o email del usuario es duplicado', false)
          } else {
            this.openSnackBar('Ha habido un error creando el usuario', false)
          }
        }
      })
    },
    goBack () {
      if (this.isNewUser) {
        eventBus.$emit('open-are-you-sure-dialog', {
          title: '¿Seguro que desea salir?',
          message: 'Los datos ingresados no se guardaran',
          onOk: () => {
            this.$router.push(this.parentRoute)
          }
        })
      } else {
        this.$router.push(this.parentRoute)
      }
    }
  },
  props: {
    userData: {
      type: Object,
      default () {
        return {}
      }
    },
    isMyAccount: {
      type: Boolean,
      default () {
        return false
      }
    },
    itemsTree: {
      type: Array,
      default () {
        return []
      }
    },
    parentRoute: String,
    backButtonText: String,
    isNewUser: {
      type: Boolean,
      default () {
        return false
      }
    },
    showStrategioAppBar: {
      type: Boolean, // Adjust the type to match the variable's type in "user" Biondo was here
      default () {
        return true
      }
    }
  },
  components: {
    ShowReportsPermisionsDialog,
    CustomSnackBar,
    AreYouSureDialog
  }
}
</script>
<style>
.strategio-my-account-sub-division {
  font-size: 24px;
  font-weight: 300;
  margin-top: 24px;
  margin-bottom: 8px;
}
.strategio-user-form-return-button {
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
}

.strategio-user-buttons {
  width: 100%;
  height: 61px !important;
  border-radius: 5px !important;
  background-color: #2262C6 !important;

}

</style>



// WEBPACK FOOTER //
// src/components/users/user-form.vue